import React, { Component } from "react";
import { Route } from "react-router-dom";

import { auth } from "../utils/auth";

import Login from "./Login";
import Comprobantes from "./Nominas/Print/Comprobantes";
import Despachados from "./Programaciones/Print/Despachados";
import Reportes from "./Reportes";
import DetalleTicket from "./Programaciones/Print/DetalleTicket";
import Solicitudes from "./Solicitudes/Print";
import Reclamaciones from "./Reclamaciones/Print";
import Reclamacion from "./Reclamaciones/Print/Reclamacion";
import Servicios from "./Servicios/Print";
import Vehiculos from "./Vehiculos/Print";
import DetalleVehiculos from "./Vehiculos/Print/ListadoDetalleVehiculos";
import Items from "./Items/Print";
import HistorialCompras from "./Items/Print/HistorialCompras";
import Empleados from "./Empleados/Print";
import DetalleEmpleados from "./Empleados/Print/ListadoDetalleEmpleados";
import GastosVehiculos from "./Gastos/Print";
import Rutas from "./Rutas/Print";
import Tarjetas from "./Programaciones/Print/Tarjetas";
import Resumen from "./Nominas/Print/Resumen";
import ComprobantesEstandard from "./Nominas/Print/ComprobantesEstandard";
import GastosGenerales from "./GastosGenerales/Print";
import Ausentes from "./Programaciones/Print/Ausentes";
import NoDespachados from "./Programaciones/Print/NoDespachados";
import DescuentosProgramados from "./DescuentosProgramados/Print";
import DescuentoProgramado from "./DescuentosProgramados/Print/Descuento";

class Imprimir extends Component {
    state = {
        isLoggedIn: auth.isLoggedIn(),
    };
    componentDidMount() {
        window.addEventListener("storage", this.syncLogout);
    }
    componentWillUnmount() {
        window.removeEventListener("storage", this.syncLogout);
        window.localStorage.removeItem("logout");
    }
    syncLogout = (event) => {
        if (event.key === "logout") {
            this.setState({ isLoggedIn: auth.isLoggedIn() });
        }
    };
    render() {
        if (!this.state.isLoggedIn) return <Login />;
        return (
            <div className='print-page'>
                <Route
                    path='/:sucursal/imprimir/nomina/:id/comprobantes'
                    component={Comprobantes}
                />
                <Route
                    path='/:sucursal/imprimir/nomina/:id/comprobantes-estandard'
                    component={ComprobantesEstandard}
                />
                <Route
                    path='/:sucursal/imprimir/nomina/:id/resumen'
                    component={Resumen}
                />
                <Route
                    path='/:sucursal/imprimir/programacion/:id/despachados'
                    component={Despachados}
                />
                <Route
                    path='/:sucursal/imprimir/programacion/:id/tarjetas'
                    component={Tarjetas}
                />
                <Route
                    path='/:sucursal/imprimir/programacion/:id/ausentes'
                    component={Ausentes}
                />
                <Route
                    path='/:sucursal/imprimir/programacion/:id/no-despachados'
                    component={NoDespachados}
                />
                <Route
                    path='/:sucursal/imprimir/ticket/:numero'
                    component={DetalleTicket}
                />
                <Route
                    path='/:sucursal/imprimir/reportes'
                    component={Reportes}
                />
                <Route
                    path='/:sucursal/imprimir/solicitudes'
                    component={Solicitudes}
                />
                <Route
                    exact
                    path='/:sucursal/imprimir/reclamaciones/:id'
                    component={Reclamacion}
                />
                <Route
                    exact
                    path='/:sucursal/imprimir/reclamaciones'
                    component={Reclamaciones}
                />
                <Route
                    path='/:sucursal/imprimir/servicios'
                    component={Servicios}
                />
                <Route
                    path='/:sucursal/imprimir/vehiculos'
                    exact
                    component={Vehiculos}
                />
                <Route
                    path='/:sucursal/imprimir/vehiculos/detalle'
                    component={DetalleVehiculos}
                />
                <Route
                    path='/:sucursal/imprimir/gastos-vehiculos'
                    component={GastosVehiculos}
                />
                <Route
                    path='/:sucursal/imprimir/gastos-generales'
                    component={GastosGenerales}
                />
                <Route path='/:sucursal/imprimir/rutas' component={Rutas} />
                <Route path='/:sucursal/imprimir/items' component={Items} />
                <Route
                    path='/:sucursal/imprimir/compras-item'
                    component={HistorialCompras}
                />
                <Route
                    path='/:sucursal/imprimir/empleados'
                    exact
                    component={Empleados}
                />
                <Route
                    path='/:sucursal/imprimir/empleados/detalle'
                    exact
                    component={DetalleEmpleados}
                />
                <Route
                    path='/:sucursal/imprimir/descuentos'
                    exact
                    component={DescuentosProgramados}
                />
                <Route
                    path='/:sucursal/imprimir/descuentos/:id'
                    exact
                    component={DescuentoProgramado}
                />
            </div>
        );
    }
}

export default Imprimir;
